import React from 'react';
import { Navigate } from 'react-router-dom';
import SuspensePage from '@/app/ui/SuspensePage';

const LandingMarketplacePage = React.lazy(() => import('@/pages/public/LandingMarketplacePage'));
const HowItWorksPage = React.lazy(() => import('@/pages/public/HowItWorksPage'));
const PacksPage = React.lazy(() => import('@/pages/public/PacksPage'));
const ServicesPage = React.lazy(() => import('@/pages/public/Services'));
const GalleryPage = React.lazy(() => import('@/pages/public/GalleryPage'));
const CatalogPage = React.lazy(() => import('@/pages/public/CatalogPage'));
const ProductDetailPage = React.lazy(() => import('@/pages/public/ProductDetailPage'));
const AppointmentsPage = React.lazy(() => import('@/pages/public/AppointmentsPage'));
const ContactPage = React.lazy(() => import('@/pages/public/ContactPage'));
const AnnoncesPage = React.lazy(() => import('@/pages/public/AnnoncesPage'));
const LegalPages = React.lazy(() => import('@/pages/public/LegalPages'));
const ServiceComingSoonPage = React.lazy(() => import('@/pages/public/ServiceComingSoonPage'));
const DevenirVendeurPage = React.lazy(() => import('@/pages/public/DevenirVendeurPage'));
const UnauthorizedPage = React.lazy(() => import('@/pages/UnauthorizedPage'));

const InstallersRouteWrapper = () => <AnnoncesPage />;

const publicRoutes = [
  {
    path: '/',
    element: (
      <SuspensePage>
        <LandingMarketplacePage />
      </SuspensePage>
    ),
  },

  // Marketplace / Catalog
  {
    path: '/marketplace',
    element: (
      <SuspensePage>
        <CatalogPage />
      </SuspensePage>
    ),
  },
  {
    path: '/catalog',
    element: (
      <SuspensePage>
        <CatalogPage />
      </SuspensePage>
    ),
  },
  {
    path: '/boutique',
    element: (
      <SuspensePage>
        <CatalogPage />
      </SuspensePage>
    ),
  },
  {
    path: '/catalogue',
    element: (
      <SuspensePage>
        <CatalogPage />
      </SuspensePage>
    ),
  },
  {
    path: '/catalog/:productId',
    element: (
      <SuspensePage>
        <ProductDetailPage />
      </SuspensePage>
    ),
  },
  {
    path: '/produit/:productId',
    element: (
      <SuspensePage>
        <ProductDetailPage />
      </SuspensePage>
    ),
  },
  {
    path: '/marketplace/:productId',
    element: (
      <SuspensePage>
        <ProductDetailPage />
      </SuspensePage>
    ),
  },

  // Installers / Annonces
  {
    path: '/installers',
    element: (
      <SuspensePage>
        <InstallersRouteWrapper />
      </SuspensePage>
    ),
  },
  {
    path: '/annonces',
    element: (
      <SuspensePage>
        <InstallersRouteWrapper />
      </SuspensePage>
    ),
  },

  // Other public pages
  {
    path: '/packs',
    element: (
      <SuspensePage>
        <PacksPage />
      </SuspensePage>
    ),
  },
  {
    path: '/comment-ca-marche',
    element: (
      <SuspensePage>
        <HowItWorksPage />
      </SuspensePage>
    ),
  },
  {
    path: '/services',
    element: (
      <SuspensePage>
        <ServicesPage />
      </SuspensePage>
    ),
  },
  {
    path: '/realisations',
    element: (
      <SuspensePage>
        <GalleryPage />
      </SuspensePage>
    ),
  },
  {
    path: '/rendez-vous',
    element: (
      <SuspensePage>
        <AppointmentsPage />
      </SuspensePage>
    ),
  },
  {
    path: '/contact',
    element: (
      <SuspensePage>
        <ContactPage />
      </SuspensePage>
    ),
  },
  {
    path: '/service-bientot',
    element: (
      <SuspensePage>
        <ServiceComingSoonPage />
      </SuspensePage>
    ),
  },
  {
    path: '/devenir-vendeur',
    element: (
      <SuspensePage>
        <DevenirVendeurPage />
      </SuspensePage>
    ),
  },
  {
    path: '/mentions-legales',
    element: (
      <SuspensePage>
        <LegalPages />
      </SuspensePage>
    ),
  },
  {
    path: '/politique-confidentialite',
    element: (
      <SuspensePage>
        <LegalPages />
      </SuspensePage>
    ),
  },
  {
    path: '/unauthorized',
    element: (
      <SuspensePage>
        <UnauthorizedPage />
      </SuspensePage>
    ),
  },
];

export default publicRoutes;
